<template>
  <div class="loader-page">
    <FriedH1>{{ message }}</FriedH1>
    <FriedSpinner />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'UniversalLoader',
  props: {
    message: {
      type: String,
      required: true,
    },
  },
});
</script>
<style lang="scss" scoped>
.loader-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  > :first-child {
    margin-bottom: var(--spacing-100);
  }
}
</style>
